<mat-card appearance="outlined">
  <mat-card-content>
    <div class="card-top-section">
      <header>{{ title }}</header>
      <div class="card-description" [laEllipsisTooltip]="description" matTooltip="" matTooltipPosition="above">
        {{ description }}
      </div>
    </div>

    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
